module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li aria-controls="'+
((__t=(id))==null?'':__t)+
'" ';
 if(typ){
__p+='uc-type="'+
((__t=(typ))==null?'':__t)+
'" ';
}
__p+='>\r\n  <div aria-label="'+
((__t=(nom))==null?'':__t)+
'" tabindex="0">\r\n    <a href="#'+
((__t=(id))==null?'':__t)+
'">\r\n        '+
((__t=(onglet))==null?'':__t)+
'\r\n    </a>\r\n    <span class="'+
((__t=(id))==null?'':__t)+
' ctime-tab-close">\r\n        <!--  <i class="material-icons cw-icon">close</i> -->\r\n        '+
((__t=(icone))==null?'':__t)+
'\r\n    </span>\r\n    </div>\r\n</li>';
}
return __p;
};
